import React from 'react';
import { SSOCallback } from '../SSOCallback/SSOCallback';

/**
 * Okta OAuth Callback Handler
 *
 * This component handles the OAuth callback from Okta/Auth0.
 * It delegates to the generic SSOCallback component which handles all SSO providers.
 */
export const OktaCallback = (): React.ReactElement | null => {
  return <SSOCallback provider='okta' callbackPath='/auth/okta/callback' />;
};
